import { render } from "./ConsultPage.vue?vue&type=template&id=bf97c404&scoped=true"
import script from "./ConsultPage.vue?vue&type=script&lang=js"
export * from "./ConsultPage.vue?vue&type=script&lang=js"

import "./ConsultPage.vue?vue&type=style&index=0&id=bf97c404&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf97c404"]])

export default __exports__